import * as schemas from "./schemas";
import { CLIENT_TOKEN } from "shadow-client";
import { HydraActions } from "shadow-client/redux";
import createHttpClient from "shadow-client/axios/createClient";
import generator from "shadow-client/endpoints/generator";

const httpClient = createHttpClient();

// payment_transactions
const paymentTransactionGenerator = generator.with(`/${CLIENT_TOKEN}/payment_transactions`, schemas.paymentTransaction);
export const savePaymentTransaction = paymentTransactionGenerator.saveEntity;
export const fetchPaymentTransaction = paymentTransactionGenerator.fetchEntity;

const paymentTransactionActions = new HydraActions(schemas.paymentTransaction);
export const postPaymentTransactionDoPayment = (entityUrl, data = {}, config = {}) => dispatch => {
  const sendRequest = httpClient.post(`${entityUrl}/do_payment`, data, config);

  return sendRequest.then(response => {
    return dispatch(paymentTransactionActions.receiveEntity(response.data));
  });
};

// invoices
const invoiceGenerator = generator.with(`/${CLIENT_TOKEN}/invoices`, schemas.invoice);
export const fetchInvoice = invoiceGenerator.fetchEntity;
export const fetchInvoicePrint = invoiceGenerator.fetchEntityFile;



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/accountingApi/index.js